/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourceinstagram2Inputs */

const en_summarysourceinstagram2 = /** @type {(inputs: Summarysourceinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_summarysourceinstagram2 = /** @type {(inputs: Summarysourceinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Summarysourceinstagram2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourceinstagram2 = /** @type {((inputs?: Summarysourceinstagram2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourceinstagram2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourceinstagram2(inputs)
	return de_summarysourceinstagram2(inputs)
});
export { summarysourceinstagram2 as "summarySourceInstagram" }